import React from "react";
import { useDrag } from "react-dnd";

// Images
import basicImg from "../../assets/images/location-basic.png";
import premiumImg from "../../assets/images/location-premium.png";

// Utils
import items from "../../utils/items";
import RealtimeConnection from "../../utils/RealtimeConnection"

export default function MainDraggableLocation({ canEdit, value }) {
	const [, drag] = useDrag({
		item: {
			type: items.location,
			isFromTeamTable: true,
			value: value
		},
		end: (item, monitor) => {
			if (monitor.didDrop()) {
				let droppedItem = monitor.getDropResult();
				if (droppedItem !== null && droppedItem.success) {
					const obj = {
						type: (value === "basic") ? "standardLocation" : "premiumLocation",
						value: 1
					}
					RealtimeConnection.decreaseTeamTable(obj)
				}
			}
		},
	});

	const canDrag = (canEdit) ? drag : null
	return (
		<>
			<div className="draggable-coins-container" ref={canDrag}>
				<img alt="draggable-coins" className="draggable-coins" src={ (value === "basic") ? basicImg : premiumImg } />
			</div>
		</>
	);
}
